import {
  retrieveSignatureRequestsV2,
  type RetrieveSignatureRequestsV2Input,
} from "@/lib/data/requests/signature-requests/signature-request";
import { queryKeys } from "@/lib/data/static";

export const retrieveSignatureRequestsV2QueryOptions = (
  input: RetrieveSignatureRequestsV2Input = {},
) => ({
  gcTime: 0,
  staleTime: 0,
  queryKey: [queryKeys.signatureRequests, "v4", input] as const,
  queryFn: () => retrieveSignatureRequestsV2(input),
});
